import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';
import EmblaClassNames from 'embla-carousel-class-names';

function init() {
  const sliders: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('.embla');

  sliders.forEach(slider => {
    const emblaOptions = {
      loop: true, 
      dragFree: false
    };
    
    const embla = EmblaCarousel(slider, emblaOptions, [ EmblaClassNames() ]);
    const carousel = slider.closest('.carousel');
    
    const dots = carousel ? carousel.querySelectorAll<HTMLElement>('.dots button, .controls button') : [];

    if (dots.length) {
      dots[0].classList.add('selected');

      // Set scroll behaviour on dots
      dots.forEach((dot: HTMLElement) => {
        dot.addEventListener('click', () => {
          embla.scrollTo(+dot.dataset.slideIdx);
          dots.forEach((dot: HTMLElement) => dot.classList.remove('selected'));
          dot.classList.add('selected');
        });
      });
      
      embla.on('select', () => {
        const selectedSelector = `[data-slide-idx='${ embla.selectedScrollSnap() }']`;
        dots.forEach((dot: HTMLElement) => dot.classList.toggle('selected', dot.matches(selectedSelector)));
      });
    }

    // If there's a synced panel, sync it with the slider
    if (slider.dataset.syncedPanel) {
      const syncedPanel = document.getElementById(slider.dataset.syncedPanel);

      if (syncedPanel) {
        embla.on('select', () => syncWith(embla, syncedPanel));
        syncWith(embla, syncedPanel);
      }
    }
  });
}

function syncWith(embla: EmblaCarouselType, syncedPanel: HTMLElement) {
  const emblaEl = embla.containerNode();
  const currentIdx = emblaEl.querySelector<HTMLElement>('.is-selected').dataset.slideIdx;
  const carousel = emblaEl.closest('.carousel');
  
  syncedPanel.querySelectorAll<HTMLElement>('[data-slide-idx]').forEach(slide => {
    const isSelected = (currentIdx == slide.dataset.slideIdx);
    slide.classList.toggle('selected', isSelected);
  });
  
  carousel && carousel.querySelectorAll<HTMLElement>('.dots button').forEach(button => {
    const isSelected = (currentIdx == button.dataset.slideIdx);
    button.classList.toggle('selected', isSelected);
  });
  
}

export default { init };
